export default "__VITE_ASSET__DcC608me__"